import { OCREntityModel } from "src/store/models/entity/ocr/entity";
import { OCRHelperModel } from "src/store/models/entity/ocr/helper";

export const encooOCRModels = {
  entity: OCREntityModel,
  helper: OCRHelperModel,
};
